import template from './informations.html';

export default informationsConfig;

/** @ngInject */
function informationsConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Konfiguracja',
    state: 'modules.informations.schedulePoints',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.informations', {
      url: '/informations',
      abstract: true,
      views: {
        'content@': {
          template,
          controller: 'InformationsController as ctrl'
        }
      },
      resolve: {
        me: SchoolCommonRoomService => SchoolCommonRoomService.getMe()
      }
    })
    .state('modules.informations.schedulePoints', {
      url: '/schedulePoints',
      views: {
        'information@modules.informations': {
          component: 'schedulePointsComponent'
        }
      }
    })
    .state('modules.informations.targets', {
      url: '/targets',
      views: {
        'information@modules.informations': {
          component: 'targetsComponent'
        }
      },
      resolve: {
        schoolCommonRoom: SchoolCommonRoomService => SchoolCommonRoomService.getSchoolCommonRoom()
      }
    })
    .state('modules.informations.activities', {
      url: '/activities',
      views: {
        'information@modules.informations': {
          component: 'activitiesComponent'
        }
      },
      resolve: {
        activities: ActivityService => ActivityService.get(null, true)
      }
    })
    .state('modules.informations.workingDays', {
      url: '/workingDays',
      views: {
        'information@modules.informations': {
          component: 'workingDaysComponent'
        }
      }
    })
    .state('modules.informations.categoriesOfDeparture', {
      url: '/categoriesOfDeparture',
      views: {
        'information@modules.informations': {
          component: 'categoriesOfDepartureComponent'
        }
      },
      resolve: {
        categoriesOfDeparture: CategoryOfDepartureService => CategoryOfDepartureService.getAll()
      }
    })
    .state('modules.informations.studentList', {
      url: '/students',
      views: {
        'information@modules.informations': {
          component: 'studentListComponent'
        }
      },
      resolve: {
        students: StudentService => StudentService.getAll(),
        groups: GroupService => GroupService.getAllGroups(),
        schoolClasses: SchoolClassService => SchoolClassService.getSchoolClass()
      }
    })
    .state('modules.informations.groups', {
      url: '/groups',
      views: {
        'information@modules.informations': {
          component: 'groupsComponent'
        }
      },
      resolve: {
        groups: GroupService => GroupService.getAllGroups(true)
      }
    })
    .state('modules.informations.employees', {
      url: '/employees',
      views: {
        'information@modules.informations': {
          component: 'employeesComponent'
        }
      },
      resolve: {
        schoolCommonRoom: SchoolCommonRoomService => SchoolCommonRoomService.getCurrentSchoolCommonRoom(),
        employees: EmployeeService => EmployeeService.getSchoolCommonRoomEmployees(),
        roles: EmployeeService => EmployeeService.getRoles()
      }
    })
    .state('modules.informations.schoolClasses', {
      url: '/schoolClasses',
      views: {
        'information@modules.informations': {
          component: 'schoolClassesComponent'
        }
      },
      resolve: {
        assignedClassRooms: ClassRoomService => ClassRoomService.getClassRooms(true),
        unassignedClassRooms: ClassRoomService => ClassRoomService.getUnassignedClassRooms(true)
      }
    })
    .state('modules.informations.permissions', {
      url: '/permissions',
      views: {
        'information@modules.informations': {
          component: 'permissionsComponent'
        }
      },
      resolve: {
        employees: EmployeeService => EmployeeService.getSchoolCommonRoomEmployees(),
        access: (AccessService, currentSchoolCommonRoom) => AccessService.getAll(currentSchoolCommonRoom.id, true)
      },
      onEnter: ($state, me) => {
        if (me.roleName !== 'MANAGER') {
          return $state.target('modules.dashboard');
        }
      }
    })
    .state('modules.informations.tags', {
      url: '/tags',
      views: {
        'information@modules.informations': {
          component: 'tagsComponent'
        }
      }
    })
    .state('modules.informations.tags.edit', {
      url: '/edit/:id',
      views: {
        'information@modules.informations': {
          component: 'editTagComponent'
        }
      },
      resolve: {
        tag: ($stateParams, TagService) => TagService.get($stateParams.id),
        groups: GroupService => GroupService.getAllGroups(true),
        schoolClasses: SchoolClassService => SchoolClassService.getSchoolClass()
      }
    });
}
